// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","634":"2c796e83","691":"component---src-pages-index-tsx","742":"9c1524af"}[chunkId] || chunkId) + "-" + {"218":"965d5bd34f92c32b2c80","313":"0307dcb0a8bc9250a6f2","634":"0ca8e62561fdbe0ff164","691":"c72309022687e9d41645","742":"3ae540ad6d9718d2c22f"}[chunkId] + ".js";
};